// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"textarea__wrapper___2fOWZ","input-count":"textarea__input-count___1y1l7","inputCount":"textarea__input-count___1y1l7","exceed-max":"textarea__exceed-max___3GedP","exceedMax":"textarea__exceed-max___3GedP","textarea":"textarea__textarea___1iUiI"};
    if(module.hot) {
      // 1771039706997
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  